import { Configuration } from "Models/configuration";
import { Consumer } from "Models/consumer";
import { Message } from "Models/message";
import { Node } from "Models/node";
import { Partition } from "Models/partition";
import { Producer } from "Models/producer";
import { GlobalState } from "./reducers/globals";

export const SET_GLOBAL = "SET_GLOBAL";
export const SET_LOG = "SET_LOG";
export const ADD_LOG_MESSAGE = "ADD_LOG_MESSAGE";
export const UPDATE_LOG_MESSAGE = "UPDATE_LOG_MESSAGE";
export const CLEAR_LOGS = "CLEAR_LOGS";

export const SET_NODES = "SET_NODES";
export const SET_CONSUMERS = "SET_CONSUMERS";
export const SET_CONFIGURATION = "SET_CONFIGURATION";
export const SET_PARITITIONS = "SET_PARITIONS";
export const SET_PRODUCER = "SET_PRODUCER";

export const UPDATE_PARTITION = "UPDATE_PARTITION";

export interface SetGlobalStateAction {
    type: typeof SET_GLOBAL;
    payload: Partial<GlobalState>;
}

export interface AddLogMsgAction {
    type: typeof ADD_LOG_MESSAGE;
    payload: { uid: string; msg: Message };
}

export interface UpdateLogMsgAction {
    type: typeof UPDATE_LOG_MESSAGE;
    payload: { uid: string; msg: Message };
}

export interface SetLogAction {
    type: typeof SET_LOG;
    payload: { uid: string; log: Message[] };
}

export interface ClearLogsAction {
    type: typeof CLEAR_LOGS;
}

export interface SetNodesAction {
    type: typeof SET_NODES;
    payload: { nodes: Node[] };
}

export interface SetConsumersAction {
    type: typeof SET_CONSUMERS;
    payload: { consumers: Consumer[] };
}

export interface SetConfigurationAction {
    type: typeof SET_CONFIGURATION;
    payload: { config?: Configuration };
}

export interface SetPartitionsAction {
    type: typeof SET_PARITITIONS;
    payload: { partitions: Partition[] };
}

export interface SetProducersAction {
    type: typeof SET_PRODUCER;
    payload: { producer: Producer | null };
}

export interface UpdatePartitionAction {
    type: typeof UPDATE_PARTITION;
    payload: { partition: Partition };
}

export type ACTION =
    | SetGlobalStateAction
    | AddLogMsgAction
    | UpdateLogMsgAction
    | SetLogAction
    | ClearLogsAction
    | SetNodesAction
    | SetConsumersAction
    | SetConfigurationAction
    | SetPartitionsAction
    | SetProducersAction
    | UpdatePartitionAction;
